// extracted by mini-css-extract-plugin
module.exports = {"submit":"component-module--submit--hsfuv","error":"component-module--error--2Y8Jg"};